Ready(() => {
  // TODO: should not be used
  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-toggle="modal"]');
    if (!trigger) return;

    e.preventDefault();
    const link = trigger.closest('a');
    const url = link ? link.getAttribute('href') : null;

    const selector = trigger.getAttribute('data-target');
    const el = document.querySelector(selector);

    // load once don't reload
    let modal = bootstrap.Modal.getInstance(el);

    // show modal as is
    if (modal) { modal.show(); return; }

    // instantiate modal
    modal = new bootstrap.Modal(el);

    // show modal unless href
    if (!url) { modal.show(); return; }

    // if href load via AJAX else
    fetch(url)
      .then(response => response.text())
      .then(data => {
        const content = el.querySelector('.modal-content');
        if (content) {
          content.innerHTML = data;
        }
        modal.show();
      })
      .catch(error => console.error('Error loading modal content:', error));
  });
})
